// removed by extract-text-webpack-plugin
module.exports = {"Favorite":"Favorite--337e8","NonFavorite":"NonFavorite--1UUDy"};